import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/maintain/moldunqualified`,
    name: 'MOLD_UNQUALIFIED_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
